import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import LookupUpload from '../../components/lookup/LookupUpload';
import '../../components/lookup/lookup.css';

/** Account-wide CSV/TXT lookup upload (CaseId IS NULL). */
export default function LookupUploadPage() {
  const navigate = useNavigate();
  return (
    <div className="lookup-upload">
      <div className="lookup-upload__breadcrumb">
        <Link to="/admin/lookup">Lookup</Link> / Upload File
      </div>
      <h1>Upload Account Lookup File</h1>
      <p className="lookup-upload__sub">
        Upload a .txt or .csv file with code + description (and any other supported fields). Map each file
        column, preview, then commit. Duplicate rows (same code + category) are skipped on commit.
      </p>

      <LookupUpload caseId={null} onCommitted={() => { /* stay on page to show results */ }} />

      <div className="lookup-upload__footer">
        <button type="button" className="lookup-btn" onClick={() => navigate('/admin/lookup')}>
          Back to Lookup
        </button>
      </div>
    </div>
  );
}
